import { Reveal, Overline, ChapterNo } from "./primitives";

const STEPS = [
  {
    no: "01",
    title: "Ritorno all'origine",
    sub: "Riscoprire la tua identità.",
    paras: [
      "Riconosci le convinzioni che ti portano a cercare approvazione, nascondere ciò che provi o dimostrare continuamente il tuo valore.",
      "Approfondiamo identità maschile e femminile cristiana, dignità e responsabilità, anche quando sono mancati riferimenti familiari presenti.",
      "Guardiamo a Gesù come riferimento di coraggio, fermezza, amore e servizio. Questa crescita entra nelle relazioni attraverso presenza e coerenza.",
    ],
  },
  {
    no: "02",
    title: "Governo del tempio",
    sub: "Creare uno spazio di scelta tra ciò che provi e ciò che fai.",
    paras: [
      "Impari a riconoscere ciò che precede una reazione o un'abitudine: stress, stanchezza, solitudine e pensieri ricorrenti.",
      "Da lì costruisci risposte diverse e routine sostenibili. La cura del corpo, il lavoro sui pensieri e la comunicazione ti aiutano a essere più presente nella vita quotidiana e nelle relazioni.",
    ],
  },
  {
    no: "03",
    title: "Chiamata in azione",
    sub: "Trasformare una direzione in passi concreti.",
    paras: [
      "Metti a fuoco talenti, valori e responsabilità. Individui ciò che desideri costruire nella famiglia, nel servizio, nel lavoro o in un progetto accantonato.",
      "Definisci un obiettivo, un primo passo e un momento di verifica. La crescita comincia a trovare spazio nelle tue giornate.",
    ],
  },
];

export const MethodSection = () => (
  <section id="metodo" className="relative py-28 sm:py-40" data-testid="method-section">
    <div className="mx-auto max-w-6xl px-6 sm:px-8">
      <Reveal className="max-w-4xl">
        <Overline>Il Metodo Tempio Vivo</Overline>
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-white">
          Riscoprire chi sei. Governare le tue scelte.{" "}
          <span className="italic text-gold">Dare una direzione alla tua vita.</span>
        </h2>
        <p className="mt-8 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-white/75">
          Il Metodo Tempio Vivo tiene insieme mente, corpo, emozioni, relazioni e chiamata. Queste
          aree si influenzano ogni giorno: per questo il percorso parte dalla persona intera.
        </p>
      </Reveal>

      <div className="relative mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3" data-testid="method-steps">
        <div className="absolute left-0 right-0 top-10 hidden h-px bg-gold/25 lg:block" aria-hidden />
        {STEPS.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.12}>
            <article className="relative h-full rounded-2xl border border-white/15 bg-white/[0.03] p-8 transition-colors duration-300 hover:border-gold/50 sm:p-10">
              <div className="flex items-center justify-between">
                <ChapterNo>{s.no}</ChapterNo>
                <span className="h-3 w-3 rounded-full bg-gold shadow-[0_0_14px_rgba(255,211,77,0.8)]" aria-hidden />
              </div>
              <h3 className="mt-8 font-serif text-2xl sm:text-3xl font-medium uppercase tracking-tight text-white">
                {s.title}
              </h3>
              <p className="mt-2 font-serif text-lg italic text-gold">{s.sub}</p>
              <div className="mt-5 space-y-4 text-sm sm:text-base font-light leading-relaxed text-white/75">
                {s.paras.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mx-auto mt-14 max-w-3xl text-center font-serif text-xl sm:text-2xl font-light italic leading-relaxed text-white/70">
          Nel percorso personale adattiamo priorità e tempi alla tua situazione. Nel coaching di
          gruppo approfondiamo queste aree attraverso un cammino condiviso.
        </p>
      </Reveal>
    </div>
  </section>
);
